<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.订单编号')}}<template slot="title">{{$t('视频-订单.订单编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.订单编号')" />
      </a-form-model-item>
      <a-form-model-item prop="outTradeNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.外部交易号')}}<template slot="title">{{$t('视频-订单.外部交易号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.outTradeNo" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.外部交易号')" />
      </a-form-model-item>
      <a-form-model-item prop="paymentType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.支付类型1余额2支付宝3微信')}}<template slot="title">{{$t('视频-订单.支付类型1余额2支付宝3微信')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="buyerId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.买家id')}}<template slot="title">{{$t('视频-订单.买家id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.buyerId"  :placeholder="$t('通用.输入.请输入')+$t('视频-订单.买家id')" />
      </a-form-model-item>
      <a-form-model-item prop="orderMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.订单总价')}}<template slot="title">{{$t('视频-订单.订单总价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderMoney"  :placeholder="$t('通用.输入.请输入')+$t('视频-订单.订单总价')" />
      </a-form-model-item>
      <a-form-model-item prop="orderStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.订单状态0 已取消，1代付款 2支付成功 ')}}<template slot="title">{{$t('视频-订单.订单状态0 已取消，1代付款 2支付成功 ')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="payTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.订单付款时间')}}<template slot="title">{{$t('视频-订单.订单付款时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="createBy" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.创建者')}}<template slot="title">{{$t('视频-订单.创建者')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.createBy" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.创建者')" />
      </a-form-model-item>
      <a-form-model-item prop="updateBy" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.更新人')}}<template slot="title">{{$t('视频-订单.更新人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.updateBy" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.更新人')" />
      </a-form-model-item>
      <a-form-model-item prop="videoId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.视频id')}}<template slot="title">{{$t('视频-订单.视频id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.videoId" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.视频id')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频-订单.备注')}}<template slot="title">{{$t('视频-订单.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('视频-订单.备注')" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrderVideo, addOrderVideo, updateOrderVideo } from '@/api/video/orderVideo'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        orderNo: null,

        outTradeNo: null,

        paymentType: null,

        buyerId: null,

        orderMoney: null,

        orderStatus: 0,

        payTime: null,

        createBy: null,

        createTime: null,

        updateBy: null,

        videoId: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        outTradeNo: [
          { required: true, message: this.$t('视频-订单.外部交易号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        paymentType: [
          { required: true, message: this.$t('视频-订单.支付类型1余额2支付宝3微信')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        buyerId: [
          { required: true, message: this.$t('视频-订单.买家id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        orderMoney: [
          { required: true, message: this.$t('视频-订单.订单总价')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        orderStatus: [
          { required: true, message: this.$t('视频-订单.订单状态0 已取消，1代付款 2支付成功 ')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderNo: null,
        outTradeNo: null,
        paymentType: null,
        buyerId: null,
        orderMoney: null,
        orderStatus: 0,
        payTime: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        videoId: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderVideo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateOrderVideo(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addOrderVideo(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
